import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'
import { SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'
import { useUnlinkCustomerModal } from './useUnlinkCustomerModal'
import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'

type UnlinkCustomerModalProps = {
  onUnlink?: () => void
  onClose: () => void
  customerId: string
  service: IntegrationServices
}

export const UnlinkCustomerModal: FC<UnlinkCustomerModalProps> = props => {
  const hook = useUnlinkCustomerModal({
    onConfirm: props.onUnlink,
    customerId: props.customerId,
    service: props.service
  })

  return (
    <SimpleModal
      isOpen
      variant="dialog"
      onClose={props.onClose}
      data-testid="modal.unlinkCustomer"
      title={`Unlink ${hook.customerName} from ${hook.serviceName}`}
      isDestructive
      disableSubmitOnEnter
      submitButtonText="Unlink"
      submittingButtonText="Unlinking..."
      cancelButtonText="Cancel"
      submitDisabled={hook.submit.disabled}
      submitting={hook.submit.unlinking}
      onSubmit={hook.submit.onClick}
    >
      <Box color={GreyGrey80} {...Primary13Regular} flex={1}>
        This will unlink the customer from {hook.serviceName} immediately. You
        can re-link the customer again if required.
      </Box>
    </SimpleModal>
  )
}
